<!-- Se usa mat-card, igual que "Información Propiedad" o "Información
     Propietarios": el bloque convivía con esas tarjetas y con marco y encabezado
     propios parecía traído de otra pantalla. -->
<ng-container *ngIf="!sinTarjeta; else soloDatos">
  <mat-card class="card-auditoria">
    <mat-card-header>
      <mat-card-title>Auditoría</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <ng-container *ngTemplateOutlet="cuerpo"></ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #soloDatos>
  <ng-container *ngTemplateOutlet="cuerpo"></ng-container>
</ng-template>


<ng-template #cuerpo>

  <!-- El de bloque (ball-atom / default), no el chiquito de los inputs. El
       position-relative acota el overlay a esta tarjeta, y el min-height le da
       lugar para dibujarse mientras todavía no hay contenido. -->
  <div class="position-relative" [class.cargando]="cargando">
    <ngx-spinner [zIndex]="100" name="spAuditoria" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
      type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <p class="tenue" *ngIf="fallo">No se pudo obtener la información de auditoría.</p>

  <p class="tenue" *ngIf="!cargando && !fallo && auditoria && !auditoria.tieneAuditoria">
    Este registro todavía no tiene información de auditoría.
  </p>

  <ng-container *ngIf="!cargando && !fallo && auditoria && auditoria.tieneAuditoria">

    <div class="row">
      <div class="col-6">
        <mat-label><b>Creado por: </b></mat-label>
        <span>{{ textoUsuario(auditoria.usuarioCreacion, auditoria.fechaCreacion) }}</span>
      </div>
      <div class="col-6">
        <mat-label><b>Fecha de alta: </b></mat-label>
        <span>{{ auditoria.fechaCreacion ? (auditoria.fechaCreacion | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <mat-label><b>Modificado por: </b></mat-label>
        <span>{{ textoUsuario(auditoria.usuarioModificacion, auditoria.fechaModificacion) }}</span>
      </div>
      <div class="col-6">
        <mat-label><b>Última modificación: </b></mat-label>
        <span>{{ auditoria.fechaModificacion ? (auditoria.fechaModificacion | date:'dd/MM/yyyy HH:mm') : 'Sin modificaciones' }}</span>
      </div>
    </div>

    <div class="row" *ngIf="auditoria.anulado != null || auditoria.fechaAnula">
      <div class="col-6">
        <mat-label><b>Estado: </b></mat-label>
        <span [class.anulado]="auditoria.anulado">{{ auditoria.anulado ? 'Anulado' : 'Vigente' }}</span>
      </div>
      <div class="col-6" *ngIf="auditoria.fechaAnula">
        <mat-label><b>Fecha de anulación: </b></mat-label>
        <span>{{ auditoria.fechaAnula | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-6" *ngIf="auditoria.origen">
        <mat-label><b>Origen: </b></mat-label>
        <span>{{ auditoria.origen }}</span>
      </div>
      <div class="col-6">
        <mat-label><b>Cambios registrados: </b></mat-label>
        <span *ngIf="auditoria.cantidadCambios > 0">
          {{ auditoria.cantidadCambios }}
          <ng-container *ngIf="auditoria.fechaUltimoCambio">
            &mdash; último el {{ auditoria.fechaUltimoCambio | date:'dd/MM/yyyy' }}
          </ng-container>
        </span>
        <span *ngIf="auditoria.cantidadCambios === 0">Sin cambios desde el alta</span>
      </div>
    </div>

    <div class="row" *ngIf="mostrarHistorial">
      <div class="col-12">
        <button mat-stroked-button color="primary" (click)="abrirHistorial()">
          <mat-icon>manage_search</mat-icon>
          Ver historial de cambios
        </button>
      </div>
    </div>

  </ng-container>

  </div>

</ng-template>
